export default __webpack_public_path__ + "static/media/arrow-right-from-bracket-solid.ed053f6c.svg";